import type { MenuLinkItemProps } from '@base-ui/react';

import { Menu as BaseMenu } from '@base-ui/react';
import { Link, type LinkProps } from 'react-router';

import { clsx } from '~/styles/utils';

import { Icon, type IconName } from '../Icon/Icon';
import { itemStyle, menuItemIconStyle } from './Menu.css';

export type Props = LinkProps &
  Pick<MenuLinkItemProps, 'label' | 'closeOnClick' | 'className'> & {
    icon?: IconName;
  };

export const MenuLinkItem = ({ children, className, closeOnClick, icon, label, ...delegated }: Props) => {
  return (
    <BaseMenu.LinkItem
      className={clsx(itemStyle, className)}
      closeOnClick={closeOnClick ?? true}
      label={label}
      render={<Link {...delegated} />}
    >
      {icon && <Icon className={menuItemIconStyle} name={icon} size={22} />}

      <span>{children}</span>
    </BaseMenu.LinkItem>
  );
};
